'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = i18N;
/**
 *@param { function } switchLanguageList 返回promise对象的语言包，如webpack的import
 * return import(`src/locale/${language}`).then(language => {});
 *@param { array } defaultLanguageList 默认语言翻译列表
 */
function i18N(switchLanguageList, defaultLanguageList) {
  var displayName = 'i18n';
  //中转作用
  var __Locale__;
  var changedLanguageList;
  /**
   *@param { object } routeControllerComponentObj 实例化后的routeController
   */
  return function (routeControllerComponentObj) {
    function switchLanguage(language) {
      var reRender = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      return switchLanguageList(language).then(function (languageList) {
        if (!languageList) {
          return false;
        }
        localStorage.currentLanguage = language;
        changedLanguageList = languageList.default;
        if (reRender) {
          routeControllerComponentObj.reRender();
        }
        return languageList.default;
      });
    }
    function t(str) {
      if (!__Locale__) {
        __Locale__ = {};
        defaultLanguageList.forEach(function (v, k) {
          __Locale__[v] = k;
        });
      }
      if (changedLanguageList) {
        var o = changedLanguageList[__Locale__[str]];
        if (o) {
          return o;
        }
      }
      return str;
    }
    if (localStorage.currentLanguage) {
      return switchLanguage(localStorage.currentLanguage, false).then(function (languageList) {
        changedLanguageList = languageList;
        return {
          displayName: displayName,
          t: t,
          switchLanguage: switchLanguage
        };
      });
    }
    return {
      displayName: displayName,
      t: t,
      switchLanguage: switchLanguage
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router-controller/libs/plugins/i18n.js
// module id = 1232
// module chunks = 0